import styles from "./TagReadsArc.module.scss";
import tagIcon from "assets/images/tag-icon.svg";
import i18n from "i18n";

export const TagsReadsArc = ({ epcsReads }) => {
  return (
    <div className={styles["tags_reads_arc"]}>
      <article>
        <div>
          <picture>
            <img src={tagIcon} alt="tag icon" />
          </picture>
          <h4>{i18n.t("tags.read")}</h4>
        </div>
        <span>{epcsReads}</span>
      </article>
    </div>
  );
};
